import { render, staticRenderFns } from "./NotificationTab.vue?vue&type=template&id=5aea9814&scoped=true&"
import script from "./NotificationTab.vue?vue&type=script&lang=js&"
export * from "./NotificationTab.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTab.vue?vue&type=style&index=0&id=5aea9814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aea9814",
  null
  
)

export default component.exports